// Route paths configuration
export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/reset-password',
  LOGIN_USER_LIST: '/login/user-list',
  DASHBOARD: '/dashboard',
  RETURNS: '/returns',
  PROVISION: '/provision',
  ADMIN: '/admin',
  ADMIN_ADD_TAN: '/admin/add-tan',
  ADMIN_EDIT_TAN: '/admin/edit-tan/:id',
  HELP_USER_MANUAL: '/help/user-manual',
  HELP_COF: '/help/cof',
  HELP_DOWNLOAD_TEMPLATES: '/help/download-templates',
  RETURNS_PREPARE: '/returns/prepare',
  RETURNS_UPLOAD: '/returns/upload',
  RETURNS_COMPUTE: '/returns/compute',
  RETURNS_ADD_RULE: '/returns/add-rule',
  DOWNLOAD: '/download',
  PREMIUM_FEATURE: '/premium-features',
  SELF_SERVICE: '/self-service',
  // Child Routes
  DASHBOARD_OVERVIEW: 'overview',
  DASHBOARD_COMPLIANCE: 'compliance',

  // Multi Territory Routes
  MT_INSIGHT: '/mt/insight',
  MT_RETURNS: '/mt/returns',
  MT_PROVISION_ADVANCE: '/mt/provision-advance',
  MT_ADMIN: '/mt/admin',
  MT_ADMIN_ENTITY: '/mt/admin/entity',
  MT_ADMIN_TAX_IDENTIFICATION_NUMBER: '/mt/admin/tax-identification-number',
  MT_ADMIN_TIN_CREATE: '/mt/admin/tax-identification-number/create',
  MT_ADMIN_TIN_EDIT: '/mt/admin/tax-identification-number/edit',
  MT_ADMIN_USER_SETUP: '/mt/admin/user-setup',
  MT_ADMIN_ASSIGN_ENTITY: '/mt/admin/assign-entity',
  MT_ADMIN_COMPLIANCE_MASTER: '/mt/admin/compliance-master',
  MT_ADMIN_EXCHANGE_RATES: '/mt/admin/exchange-rates',
  MT_RETURNS_DEFINE: '/mt/returns/define',
  MT_RETURNS_DEFINE_ADD_RULE: '/mt/returns/define/rule_setting/add-rule',
  MT_RETURNS_DEFINE_DUPLICATION_RULE_FORM:
    '/mt/returns/define/DUPLICATION_RULE/add-rule',
  MT_RETURNS_DEFINE_DUPLICATION_RULE_EDIT:
    '/mt/returns/define/DUPLICATION_RULE/edit-rule',
  MT_RETURNS_UPLOAD: '/mt/returns/upload',
  MT_RETURNS_PREPARE: '/mt/returns/prepare',
  MT_RETURNS_COMPUTE: '/mt/returns/compute',
  MT_RETURNS_ALLOCATE: '/mt/returns/allocate',
  MT_RETURNS_RETURNS: '/mt/returns/returns',
  MT_RETURNS_REPORTS: '/mt/returns/reports',
  // Child route segments (relative paths for nested routing)
  MT_RETURNS_DEFINE_CHILD: 'define',
  MT_RETURNS_UPLOAD_CHILD: 'upload',
  MT_RETURNS_PREPARE_CHILD: 'prepare',
  MT_RETURNS_COMPUTE_CHILD: 'compute',
  MT_RETURNS_ALLOCATE_CHILD: 'allocate',
  MT_RETURNS_RETURNS_CHILD: 'returns',
  MT_RETURNS_REPORTS_CHILD: 'reports',
  MT_ADMIN_ENTITY_CHILD: 'entity',
  MT_ADMIN_TAX_IDENTIFICATION_NUMBER_CHILD: 'tax-identification-number',
  MT_ADMIN_USER_SETUP_CHILD: 'user-setup',
  MT_ADMIN_ASSIGN_ENTITY_CHILD: 'assign-entity',
  MT_ADMIN_COMPLIANCE_MASTER_CHILD: 'compliance-master',
  MT_ADMIN_EXCHANGE_RATES_CHILD: 'exchange-rates',
}

// Route metadata
export const ROUTE_CONFIG = {
  // login
  [ROUTES.LOGIN]: {
    title: 'Login - PWC Navigate Withholding Tax',
    description: 'Login to PWC Navigate Withholding Tax platform',
    requiresAuth: false,
    redirectIfAuth: ROUTES.DASHBOARD,
  },
  [ROUTES.LOGIN_USER_LIST]: {
    title: 'Login - PWC Navigate Withholding Tax',
    description: 'Login to PWC Navigate Withholding Tax platform',
    requiresAuth: false,
    redirectIfAuth: ROUTES.DASHBOARD,
  },
  [ROUTES.FORGOT_PASSWORD]: {
    title: 'Forgot - PWC Navigate Withholding Tax',
    description: 'Login to PWC Navigate Withholding Tax platform',
    requiresAuth: false,
    redirectIfAuth: ROUTES.LOGIN,
  },
  // dashboard
  [ROUTES.DASHBOARD]: {
    title: 'Dashboard - PWC Navigate Withholding Tax',
    description: 'PWC Navigate Withholding Tax Dashboard',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
  },
  // provision
  [ROUTES.PROVISION]: {
    title: 'Provision & Advance - PWC Navigate Withholding Tax',
    description: 'Handle provision and advance knock off processes',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
  },
  // admin routes
  [ROUTES.ADMIN]: {
    title: 'Admin - PWC Navigate Withholding Tax',
    description: 'Administrative functions and system management',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
    roles: ['admin'],
  },
  [ROUTES.ADMIN_ADD_TAN]: {
    title: 'Add TAN Master - PWC Navigate Withholding Tax',
    description: 'Create new TAN master data',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
    roles: ['admin'],
  },
  [ROUTES.ADMIN_EDIT_TAN]: {
    title: 'Edit TAN Master - PWC Navigate Withholding Tax',
    description: 'Edit existing TAN master data',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
    roles: ['admin'],
  },
  // helps routes
  [ROUTES.HELP_USER_MANUAL]: {
    title: 'User Manual - PWC Navigate Withholding Tax',
    description: 'User manual and documentation',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
  },
  [ROUTES.HELP_COF]: {
    title: 'COF - PWC Navigate Withholding Tax',
    description: 'Certificate of Filing management',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
  },
  [ROUTES.HELP_DOWNLOAD_TEMPLATES]: {
    title: 'Download Templates - PWC Navigate Withholding Tax',
    description: 'Download various templates and forms',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
  },

  // Returns

  [ROUTES.RETURNS_PREPARE]: {
    title: 'Prepare Returns - PWC Navigate Withholding Tax',
    description: 'Prepare tax returns for submission',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
    roles: ['admin'],
  },
  [ROUTES.RETURNS_UPLOAD]: {
    title: 'Upload Returns - PWC Navigate Withholding Tax',
    description: 'Upload tax returns for processing',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
    roles: ['admin'],
  },

  [ROUTES.RETURNS_COMPUTE]: {
    title: 'Compute Returns - PWC Navigate Withholding Tax',
    description: '',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.RETURNS_COMPUTE,
    roles: ['admin'],
  },
  [ROUTES.DOWNLOAD]: {
    title: 'Download Status - PWC Navigate Withholding Tax',
    description: 'View and manage download status',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
    roles: ['admin'],
  },
  [ROUTES.PREMIUM_FEATURE]: {
    title: 'Premium Feature - PWC Navigate Withholding Tax',
    description: 'View and manage Premium Features',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
    roles: ['IT_ADMIN'],
  },
  [ROUTES.SELF_SERVICE]: {
    title: 'Self Service - PWC Navigate Withholding Tax',
    description: 'Self Service embedded reporting / data warehouse',
    requiresAuth: true,
    redirectIfNoAuth: ROUTES.LOGIN,
  },
}

export default ROUTES
